module.exports = __webpack_public_path__ + "media/images/favicons/apple-icon-120x120-4964e4a9daddfc4692b6ca1a68a21093.png";